import { theme } from '@align-cpf/uikit-styles';

export const colorVariants = Object.keys(theme.colors);
export const spacingVariants = Object.keys(theme.spacing);

export type ColorVariant = keyof typeof theme.colors;
export type SpacingVariant = keyof typeof theme.spacing;
